enum SubscriptionTimezoneCountry {
  albania = "albania",
  andorra = "andorra",
  austria = "austria",
  belarus = "belarus",
  belgium = "belgium",
  bulgaria = "bulgaria",
  czech_republic = "czech_republic",
  estonia = "estonia",
  finland = "finland",
  france = "france",
  french_guiana = "french_guiana",
  guadeloupe = "guadeloupe",
  germany = "germany",
  gibraltar = "gibraltar",
  greece = "greece",
  hungary = "hungary",
  ireland = "ireland",
  italy = "italy",
  latvia = "latvia",
  lithuania = "lithuania",
  malta = "malta",
  moldova = "moldova",
  poland = "poland",
  portugal = "portugal",
  romania = "romania",
  russia = "russia",
  serbia = "serbia",
  spain = "spain",
  switzerland = "switzerland",
  turkey = "turkey",
  ukraine = "ukraine",
  united_kingdom = "united_kingdom",
}

export const subscriptionTimezoneCountryAsString = (
  subscriptionTimezoneCountry: SubscriptionTimezoneCountry
): string => {
  switch (subscriptionTimezoneCountry) {
    case SubscriptionTimezoneCountry.albania:
      return "Albanie";
    case SubscriptionTimezoneCountry.andorra:
      return "Andorre";
    case SubscriptionTimezoneCountry.austria:
      return "Autriche";
    case SubscriptionTimezoneCountry.belarus:
      return "Biélorussie";
    case SubscriptionTimezoneCountry.belgium:
      return "Belgique";
    case SubscriptionTimezoneCountry.bulgaria:
      return "Bulgarie";
    case SubscriptionTimezoneCountry.czech_republic:
      return "République tchèque";
    case SubscriptionTimezoneCountry.estonia:
      return "Estonie";
    case SubscriptionTimezoneCountry.finland:
      return "Finlande";
    case SubscriptionTimezoneCountry.france:
      return "France";
    case SubscriptionTimezoneCountry.french_guiana:
      return "Guyane française";
    case SubscriptionTimezoneCountry.guadeloupe:
      return "Guadeloupe (France)";
    case SubscriptionTimezoneCountry.germany:
      return "Allemagne";
    case SubscriptionTimezoneCountry.gibraltar:
      return "Gibraltar";
    case SubscriptionTimezoneCountry.greece:
      return "Grèce";
    case SubscriptionTimezoneCountry.hungary:
      return "Hongrie";
    case SubscriptionTimezoneCountry.ireland:
      return "Irlande";
    case SubscriptionTimezoneCountry.italy:
      return "Italie";
    case SubscriptionTimezoneCountry.latvia:
      return "Lettonie";
    case SubscriptionTimezoneCountry.lithuania:
      return "Lituanie";
    case SubscriptionTimezoneCountry.malta:
      return "Malte";
    case SubscriptionTimezoneCountry.moldova:
      return "Moldavie";
    case SubscriptionTimezoneCountry.poland:
      return "Pologne";
    case SubscriptionTimezoneCountry.portugal:
      return "Portugal";
    case SubscriptionTimezoneCountry.romania:
      return "Roumanie";
    case SubscriptionTimezoneCountry.russia:
      return "Russie";
    case SubscriptionTimezoneCountry.serbia:
      return "Serbie";
    case SubscriptionTimezoneCountry.spain:
      return "Espagne";
    case SubscriptionTimezoneCountry.switzerland:
      return "Suisse";
    case SubscriptionTimezoneCountry.turkey:
      return "Turquie";
    case SubscriptionTimezoneCountry.ukraine:
      return "Ukraine";
    case SubscriptionTimezoneCountry.united_kingdom:
      return "Royaume-Uni";
  }
};

export default SubscriptionTimezoneCountry;
